import { Modal } from '@eventbrite/eds-modal';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { RATING_DETAIL_MODAL_TRACKING_METHODS } from '../../constants';
import { ModalTypes, RatingData } from '../../types';
import { BetaTag } from '../shared/betaTag/BetaTag';
import { Disclaimer } from '../shared/disclaimer/Disclaimer';
import { RatingSummary } from '../shared/ratingSummary/RatingSummary';
import { AboutRatingCard } from './AboutRatingCard';
import { CommingSoonMessage } from './CommingSoonMessage';
import './RatingDetailModal.scss';

interface RatingDetailModalProps {
    isShown: boolean;
    onClose: Function;
    ratingData?: RatingData;
    organizerName?: string;
    type: ModalTypes;
    domain?: string;
    organizerId: string;
    trackCategory: string;
    trackingMethods: string[];
}

export const RatingDetailModal = ({
    isShown,
    onClose,
    ratingData,
    organizerName,
    type,
    domain,
    organizerId,
    trackCategory,
    trackingMethods,
}: RatingDetailModalProps) => {
    const { rating } = ratingData || {};

    const trackHelperCenterLinkEvent = (link: string) => {
        trackingMethods &&
            trackingMethods.forEach((platform) => {
                return RATING_DETAIL_MODAL_TRACKING_METHODS[
                    platform as keyof typeof RATING_DETAIL_MODAL_TRACKING_METHODS
                ].HELPER_CENTER_CLICK(trackCategory, organizerId, link);
            });
    };

    return (
        <Modal
            noMinHeight={true}
            isShown={isShown}
            onClose={onClose}
            dangerouslySetContainerClassName={{ __className: 'rating-modal' }}
        >
            <div className="rating-modal__container" data-testid="rating-modal">
                <div className="rating-modal__title">
                    <h3 className="eds-text-hs">{gettext('Ratings')}</h3>
                    <BetaTag />
                </div>
                <h4 className="eds-text-bl">{organizerName}</h4>
                {ratingData && <RatingSummary ratingData={ratingData} />}
                {type === 'organizer' && (
                    <AboutRatingCard
                        rating={rating}
                        domain={domain}
                        trackHelperCenterLinkEvent={trackHelperCenterLinkEvent}
                    />
                )}
                {type === 'organizer' && <CommingSoonMessage />}
                {type === 'attendee' && (
                    <Disclaimer
                        trackHelperCenterLinkEvent={trackHelperCenterLinkEvent}
                    />
                )}
            </div>
        </Modal>
    );
};
